/* ~~~~~~~~~~ Plugins ~~~~~~~~~~ */

    /* ~~~~~ Chosen ~~~~~ */

        import "chosen-js";

/* ~~~~~~~~~~ Custom Functions ~~~~~~~~~~ */

    (function($){

        $(document).ready(function() {

            const searchParams = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            
            if(searchParams != null){
                if(searchParams.paket == 1){
                    $(".gfield.coupon.field_sublabel_below.field_description_below.gfield_visibility_visible").css({display: 'none'})
                }
            }

            /* ~~~~~~~~~~ Packets ~~~~~~~~~~ */

                    // Define Packets class
                let $appendPacketsToGravity = $('.js-append-to-gravity').html(),

                    // Define Packets Radio Buttons in Gravity class
                    $packetsRadio = $('.packets-radio'),

                    // Define Packets Radio Buttons inputs
                    $packet1 = $packetsRadio.find('.ginput_container .gfield_radio li:first-of-type input'),
                    $packet2 = $packetsRadio.find('.ginput_container .gfield_radio li:nth-of-type(2) input'),
                    $packet3 = $packetsRadio.find('.ginput_container .gfield_radio li:nth-of-type(3) input');


                // Append Packets from HTML to Packets Radio Buttons in Gravity Forms
                $('.packets-radio').append($appendPacketsToGravity);

                $('.register-form .register-form__content-wrapper > .js-append-to-gravity').addClass('d-none');

                // Add classes for effect CSS when you click on Single Packet
                $('.js-single-type-radio-button').on('click', function() {
                    let baseString = $(this).find('.single-type__number').text();
                    let paketNumber = baseString.split("").pop();
                    window.location.search = "?paket="+paketNumber
                    $('.js-single-type-radio-button').not($(this)).removeClass('single-type-radio-button--active');
                    $(this).addClass('single-type-radio-button--active');
                });

                // Functions on click and if paket argument is correct each of Sigle Packet
                $('.js-single-type-radio-button-1').on('click', function() {
                    $packet1.click();
                    $('.js-single-type-radio-button-1').addClass('single-type-radio-button--active');
                });

                if ($('.js-single-type-radio-button-selected-1').length) {
                    $packet1.click();
                }

                $('.js-single-type-radio-button-2').on('click', function() {
                    $packet2.click();
                    $('.js-single-type-radio-button-2').addClass('single-type-radio-button--active');
                });

                if ($('.js-single-type-radio-button-selected-2').length) {
                    $packet2.click();
                }

                $('.js-single-type-radio-button-3').on('click', function() {
                    $packet3.click();
                    $('.js-single-type-radio-button-3').addClass('single-type-radio-button--active');
                });

                if ($('.js-single-type-radio-button-selected-3').length) {
                    $packet3.click();
                }


            /* ~~~~~~~~~~ Coupon ~~~~~~~~~~ */

                // Define Coupon Field
                let $couponGfield = $('.gform_wrapper form .gform_body .gform_fields .coupon');

                // Create and append div
                $("<div class='coupon__content-wrapper'></div>").insertBefore($couponGfield.find('.gfield_label'));

                // Appends Label and Description to div created line up
                $couponGfield.find('.gfield_description, .gfield_label').appendTo($couponGfield.find('.coupon__content-wrapper'));

                // CSS classes for input button in Coupon
                $couponGfield.find('.gf_coupon_code').on("change paste keyup", function() {
                    $(this).next().removeClass('gf-default-disabled');
                    $(this).next().attr('disabled', false);

                    if($(this).val() == 0) {
                        $(this).next().addClass('gf-default-disabled');
                        $(this).next().attr('disabled', true);
                    }
                });

                $("#gf_coupon_button").click(function() {
                    setTimeout(function() {
                        if($("#gf_coupon_codes_1").val()) {
                            $(".gf_coupon_name_container a").attr('onclick', false);

                            $(".gf_coupon_name_container a").on('click', function(){
                                DeleteCoupon($("#gf_coupon_codes_1").val(), '1');
                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled");
                                $(".members-used-coupon-error").addClass("d-none");
                            });

                            if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length == 2) {
                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                    $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                });
                            }

                            $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                $(this).find(".gfield_repeater_buttons .add_repeater_item").on('click', function() {
                                    if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length == 2) {
                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                            $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                        });
                                    }
                                });
                            });

                            if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length > 2) {
                                $(".members-used-coupon-error").removeClass("d-none");
                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                    $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                });

                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").slice(2).each(function(){
                                    $(this).remove();
                                });
                            }

//                            let packet2Price = 0,
//                                packet3Price = 790;
//
//                            $(".js-single-type-radio-button-2 .single-packet-price").text(packet2Price);
//                            $(".js-single-type-radio-button-3 .single-packet-price").text(packet3Price);
                        }
                    }, 3000);
                });

                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                    $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this) };');
                });


            /* ~~~~~~~~~~ Members ~~~~~~~~~~ */

                // Define Single Repeater Item
                let $singleRepeaterItem = $('.members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item');

                // Add Number of Repeater Item and Icon Before Single Single Repeater Item
                $('<div class="d-flex align-items-center w-100"><div class="icon-member c-mr-3"></div><h2 class="member-number text-uppercase">Teilnehmer</h2></div>').insertBefore($singleRepeaterItem.find('.gfield_repeater_cell:first-of-type'));


            /* ~~~~~~~~~~ Keydown for Number ~~~~~~~~~~ */

                $(".ginput_container_number input").keydown(function (e) {
                    // Allow: backspace, delete, tab, escape, enter
                    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                         // Allow: Ctrl/cmd+A
                        (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                         // Allow: Ctrl/cmd+C
                        (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                         // Allow: Ctrl/cmd+X
                        (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                         // Allow: +
                        (e.keyCode == 187) || (e.keyCode == 61) ||
                        // Allow: home, end, left, right
                        (e.keyCode >= 35 && e.keyCode <= 39)) {
                             // let it happen, don't do anything
                             return;
                    }
                    // Ensure that it is a number and stop the keypress
                    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                        e.preventDefault();
                    }
                });


            /* ~~~~~~~~~~ Keydown for Phone Number ~~~~~~~~~~ */

                var max_chars = 16;

                $(".ginput_container_phone input").keyup( function(){
                    if ($(this).val().length >= max_chars) {
                        $(this).val($(this).val().substr(0, max_chars));
                    }
                });

                $(".ginput_container_phone input").keydown(function (e) {

                    if ($(this).val().length >= max_chars) {
                        $(this).val($(this).val().substr(0, max_chars));
                    }

                    // Allow: backspace, delete, tab, escape, enter
                    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                         // Allow: Ctrl/cmd+A
                        (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                         // Allow: Ctrl/cmd+C
                        (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                         // Allow: Ctrl/cmd+X
                        (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                         // Allow: +
                        (e.keyCode == 187) || (e.keyCode == 61) ||
                        // Allow: home, end, left, right
                        (e.keyCode >= 35 && e.keyCode <= 39)) {
                             // let it happen, don't do anything
                             return;
                    }
                    // Ensure that it is a number and stop the keypress
                    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                        e.preventDefault();
                    }
                });


            /* ~~~~~~~~~~ Radio Button ~~~~~~~~~~ */

                $(".gfield_radio li label").each(function() {
                    $("<div class='check'></div>").appendTo($(this));
                });

                $(".gfield_radio > li >  input[type=radio]").click(function() {
                    if($(this).prop("checked") === true) {
                        $(this).next().addClass("active");
                        $(".gfield_radio > li >  input[type=radio]").not(this).next().removeClass("active");
                    }
                });

                $(".gfield_radio > li >  input[type=radio]").each(function() {
                    if($(this).prop("checked") === true) {
                        $(this).next().addClass("active");
                    }
                });


            /* ~~~~~~~~~~ Add Upload button ~~~~~~~~~~ */

                if($(".ginput_container_fileupload").length) {
                    $(".ginput_container_fileupload input[type='file']").each(function(){
                        $(this).wrap("<div class='upload-btn-wrapper'></div>");
                    });

                    $("<button class='button-upload crunch-button crunch-button__outline crunch-button__outline--primary-color'>Browse...</button><span id='file-name'></span>").appendTo(".ginput_container_fileupload .upload-btn-wrapper");

                    $(".ginput_container_fileupload .upload-btn-wrapper input[type='file']").hover(
                        function() {
                            $(this).next().focus();
                        }, function() {
                            $(this).next().blur();
                        }
                    );

                    $(".ginput_container_fileupload .upload-btn-wrapper input[type='file']").each(function(){
                        $(this).on("change", function() {
                            var file = $(this)[0].files[0].name;
                            var buttonUploadWidth = $(".button-upload").outerWidth();
                            $(this).next().next().addClass("active").text(file);
                            $(this).width(buttonUploadWidth);
                        });
                    });
                }


            /* ~~~~~~~~~~ Contact and Press Form Columns ~~~~~~~~~~ */

                // Define Columns
                let firstConcactPresseColumn = $('.gform_wrapper form .gform_body #gform_fields_3 .gfmc-row-1-col-1-of-2, .gform_wrapper form .gform_body #gform_fields_4 .gfmc-row-1-col-1-of-2'),
                    secondConcactPresseColumn = $('.gform_wrapper form .gform_body #gform_fields_3 .gfmc-row-1-col-2-of-2, .gform_wrapper form .gform_body #gform_fields_4 .gfmc-row-1-col-2-of-2');

                if ($(window).width() <= 640) {
                    // Change Order Columns
                    firstConcactPresseColumn.insertAfter(firstConcactPresseColumn.next());

                    // Change Order Phone Number Field
                    firstConcactPresseColumn.find('.contact-press-phone-number').insertBefore(secondConcactPresseColumn.children().children().first());
                }

                $(window).on("resize", function() {
                    if ($(window).width() <= 640) {
                        // Change Order Columns
                        firstConcactPresseColumn.insertAfter(firstConcactPresseColumn.next());

                        // Change Order Phone Number Field
                        firstConcactPresseColumn.find('.contact-press-phone-number').insertBefore(secondConcactPresseColumn.children().children().first());
                    } else {
                        // Change Order Columns
                        secondConcactPresseColumn.insertAfter(firstConcactPresseColumn);

                        // Change Order Phone Number Field
                        secondConcactPresseColumn.find('.contact-press-phone-number').insertBefore(firstConcactPresseColumn.children().children().first());
                    }
                });

            /* ~~~~~~~~~~ Contact Submit Button Acceptacne ~~~~~~~~~~ */

                let submitContactPressButton = $('#gform_wrapper_3 form .gform_footer button[type="submit"].gform_button, #gform_wrapper_4 form .gform_footer button[type="submit"].gform_button'),
                    acceptanceCheckbox = $(".gform_wrapper form .gform_body .gform_fields .acceptance-contact-press .gfield_checkbox li input[type=checkbox]");

                submitContactPressButton.wrap("<div class='submit-button-wrapper d-inline-block no-drop'></div>");

                if(acceptanceCheckbox.is(":checked")) {
                    submitContactPressButton
                        .removeClass("gf-default-disabled")
                        .parent().removeClass("no-drop");
                } else {
                    submitContactPressButton
                        .addClass("gf-default-disabled")
                        .parent().addClass("no-drop");
                }

                acceptanceCheckbox.change(function(){
                    if(acceptanceCheckbox.is(":checked")) {
                        submitContactPressButton
                            .removeClass("gf-default-disabled")
                            .parent().removeClass("no-drop");
                    } else {
                        submitContactPressButton
                            .addClass("gf-default-disabled")
                            .parent().addClass("no-drop");
                    }
                });


            /* ~~~~~~~~~~ After Submit ~~~~~~~~~~ */

                jQuery(document).bind("gform_post_render", function() {

                    /* ~~~~~~~~~~ Packets ~~~~~~~~~~ */

                            // Define Packets class
                        let $appendPacketsToGravity = $('.register-form .register-form__content-wrapper > .js-append-to-gravity').html(),

                            // Define Packets Radio Buttons in Gravity class
                            $packetsRadio = $('.packets-radio'),

                            // Define Packets Radio Buttons inputs
                            $packet1 = $packetsRadio.find('.ginput_container .gfield_radio li:first-of-type input'),
                            $packet2 = $packetsRadio.find('.ginput_container .gfield_radio li:nth-of-type(2) input'),
                            $packet3 = $packetsRadio.find('.ginput_container .gfield_radio li:nth-of-type(3) input');


                        // Append Packets from HTML to Packets Radio Buttons in Gravity Forms
                        $packetsRadio.append($appendPacketsToGravity);

                        // Add classes for effect CSS when you click on Single Packet
                        $('.js-single-type-radio-button').on('click', function() {
                            $('.js-single-type-radio-button').not($(this)).removeClass('single-type-radio-button--active');
                            $(this).addClass('single-type-radio-button--active');
                        });

                        // Functions on click and if paket argument is correct each of Sigle Packet
                        $('.js-single-type-radio-button-1').on('click', function() {
                            $packet1.click();
                            $('.js-single-type-radio-button-1').addClass('single-type-radio-button--active');
                        });

                        $('.js-single-type-radio-button-2').on('click', function() {
                            $packet2.click();
                            $('.js-single-type-radio-button-2').addClass('single-type-radio-button--active');
                        });

                        $('.js-single-type-radio-button-3').on('click', function() {
                            $packet3.click();
                            $('.js-single-type-radio-button-3').addClass('single-type-radio-button--active');
                        });

                        // Add Match Height for Single Type Box
                        $('.single-type-radio-button .single-type').matchHeight();

                        /* ~~~~~~~~~~ Coupon ~~~~~~~~~~ */

                        // Define Coupon Field
                        let $couponGfield = $('.gform_wrapper form .gform_body .gform_fields .coupon');

                        // Create and append div
                        $("<div class='coupon__content-wrapper'></div>").insertBefore($couponGfield.find('.gfield_label'));

                        // Appends Label and Description to div created line up
                        $couponGfield.find('.gfield_description, .gfield_label').appendTo($couponGfield.find('.coupon__content-wrapper'));

                        // CSS classes for input button in Coupon
                        $couponGfield.find('.gf_coupon_code').on("change paste keyup", function() {
                            $(this).next().removeClass('gf-default-disabled');
                            $(this).next().attr('disabled', false);

                            if($(this).val() == 0) {
                                $(this).next().addClass('gf-default-disabled');
                                $(this).next().attr('disabled', true);
                            }
                        });

                        $("#gf_coupon_button").click(function() {
                            setTimeout(function() {
                                if($("#gf_coupon_codes_1").val()) {
                                    $(".gf_coupon_name_container a").attr('onclick', false);

                                    $(".gf_coupon_name_container a").on('click', function(){
                                        DeleteCoupon($("#gf_coupon_codes_1").val(), '1');
                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled");
                                        $(".members-used-coupon-error").addClass("d-none");
                                    });

                                    if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length == 2) {
                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                            $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                        });
                                    }

                                    $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                        $(this).find(".gfield_repeater_buttons .add_repeater_item").on('click', function() {
                                            if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length == 2) {
                                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                                    $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                                });
                                            }
                                        });
                                    });

                                    if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length > 2) {
                                        $(".members-used-coupon-error").removeClass("d-none");
                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                            $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                        });

                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").slice(2).each(function(){
                                            $(this).remove();
                                        });
                                    }

//                                    let packet2Price = 0,
//                                        packet3Price = 790;
//
//                                    $(".js-single-type-radio-button-2 .single-packet-price").text(packet2Price);
//                                    $(".js-single-type-radio-button-3 .single-packet-price").text(packet3Price);
                                }
                            }, 3000);
                        });

                        if($("#gf_coupon_codes_1").val()) {
                            $(".gf_coupon_name_container a").attr('onclick', false);

                            $(".gf_coupon_name_container a").on('click', function(){
                                DeleteCoupon($("#gf_coupon_codes_1").val(), '1');
                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled");
                                $(".members-used-coupon-error").addClass("d-none");
                            });

                            if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length == 2) {
                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                    $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                });
                            }

                            $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                $(this).find(".gfield_repeater_buttons .add_repeater_item").on('click', function() {
                                    if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length == 2) {
                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                            $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                        });
                                    }
                                });
                            });

                            if($(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items").find('.gfield_repeater_item').length > 2) {
                                $(".members-used-coupon-error").removeClass("d-none");
                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", true).addClass("gf-default-disabled");

                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                                    $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this);$(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item .gfield_repeater_buttons .add_repeater_item").prop("disabled", false).removeClass("gf-default-disabled"); };');
                                });

                                $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").slice(2).each(function(){
                                    $(this).remove();
                                });
                            }
                        }

                        $(".members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item").each(function(){
                            $(this).find('.gfield_repeater_buttons .remove_repeater_item').attr('onclick', 'if(confirm("Möchten Sie dieses Objekt wirklich entfernen?")){ gformDeleteRepeaterItem(this) };');
                        });


                    /* ~~~~~~~~~~ Members ~~~~~~~~~~ */

                        // Define Single Repeater Item
                        let $singleRepeaterItem = $('.members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item');

                        // Add Number of Repeater Item and Icon Before Single Single Repeater Item
                        $('<div class="d-flex align-items-center w-100"><div class="icon-member c-mr-3"></div><h2 class="member-number text-uppercase">Teilnehmer</h2></div>').insertBefore($singleRepeaterItem.find('.gfield_repeater_cell:first-of-type'));


                    /* ~~~~~~~~~~ Submit Button Acceptacne ~~~~~~~~~~ */

                        let submitButton = $(".gform_wrapper form .gform_body #gform_page_1_3 .gform_page_footer button[type='submit'].gform_button"),
                            acceptanceCheckbox = $(".gform_wrapper form .gform_body #gform_page_1_3 .gform_page_fields .acceptance-register .gfield_checkbox");

                        submitButton.wrap("<div class='submit-button-wrapper d-inline-block no-drop'></div>");

                        if(acceptanceCheckbox.find("li:first-of-type input[type=checkbox]").is(":checked") && acceptanceCheckbox.find("li:nth-of-type(2) input[type=checkbox]").is(":checked")) {
                            submitButton
                                .removeClass("gf-default-disabled")
                                .parent().removeClass("no-drop");
                        } else {
                            submitButton
                                .addClass("gf-default-disabled")
                                .parent().addClass("no-drop");
                        }

                        acceptanceCheckbox.change(function(){
                            if(acceptanceCheckbox.find("li:first-of-type input[type=checkbox]").is(":checked") && acceptanceCheckbox.find("li:nth-of-type(2) input[type=checkbox]").is(":checked")) {
                                submitButton
                                    .removeClass("gf-default-disabled")
                                    .parent().removeClass("no-drop");
                            }
                            else {
                                submitButton
                                    .addClass("gf-default-disabled")
                                    .parent().addClass("no-drop");
                            }
                        });


                    /* ~~~~~~~~~~ Keydown for Number ~~~~~~~~~~ */

                        $(".ginput_container_number input").keydown(function (e) {
                            // Allow: backspace, delete, tab, escape, enter
                            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                                 // Allow: Ctrl/cmd+A
                                (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                                 // Allow: Ctrl/cmd+C
                                (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                                 // Allow: Ctrl/cmd+X
                                (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                                 // Allow: +
                                (e.keyCode == 187) || (e.keyCode == 61) ||
                                // Allow: home, end, left, right
                                (e.keyCode >= 35 && e.keyCode <= 39)) {
                                     // let it happen, don't do anything
                                     return;
                            }
                            // Ensure that it is a number and stop the keypress
                            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                                e.preventDefault();
                            }
                        });


                    /* ~~~~~~~~~~ Keydown for Phone Number ~~~~~~~~~~ */

                        var max_chars = 16;

                        $(".ginput_container_phone input").keyup( function(){
                            if ($(this).val().length >= max_chars) {
                                $(this).val($(this).val().substr(0, max_chars));
                            }
                        });

                        $(".ginput_container_phone input").keydown(function (e) {

                            if ($(this).val().length >= max_chars) {
                                $(this).val($(this).val().substr(0, max_chars));
                            }

                            // Allow: backspace, delete, tab, escape, enter
                            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                                 // Allow: Ctrl/cmd+A
                                (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                                 // Allow: Ctrl/cmd+C
                                (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
                                 // Allow: Ctrl/cmd+X
                                (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
                                 // Allow: +
                                (e.keyCode == 187) || (e.keyCode == 61) ||
                                // Allow: home, end, left, right
                                (e.keyCode >= 35 && e.keyCode <= 39)) {
                                     // let it happen, don't do anything
                                     return;
                            }
                            // Ensure that it is a number and stop the keypress
                            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                                e.preventDefault();
                            }
                        });


                    /* ~~~~~~~~~~ Add Upload button ~~~~~~~~~~ */

                        if(!$(".upload-btn-wrapper").length) {
                            $(".ginput_container_fileupload input[type='file']").each(function(){
                                $(this).wrap("<div class='upload-btn-wrapper'></div>");
                            });

                            $("<button class='button-upload crunch-button crunch-button__outline crunch-button__outline--primary-color'>Browse...</button><span id='file-name'></span>").appendTo(".ginput_container_fileupload .upload-btn-wrapper");

                            $(".ginput_container_fileupload .upload-btn-wrapper input[type='file']").hover(
                                function() {
                                    $(this).next().focus();
                                }, function() {
                                    $(this).next().blur();
                                }
                            );

                            $(".ginput_container_fileupload .upload-btn-wrapper input[type='file']").each(function(){
                                $(this).on("change", function() {
                                    var file = $(this)[0].files[0].name;
                                    var buttonUploadWidth = $(".button-upload").outerWidth();
                                    $(this).next().next().addClass("active").text(file);
                                    $(this).width(buttonUploadWidth);
                                });
                            });
                        }

                    /* ~~~~~~~~~~ Radio Button ~~~~~~~~~~ */

                        $(".radio-buttons-wrapper").each(function(){
                            $(this).prev().insertBefore($(this).find(".ginput_container_radio"));
                        });

                        $(".gfield_radio li label").each(function() {
                            $("<div class='check'></div>").appendTo($(this));
                        });

                        $(".gfield_radio > li >  input[type=radio]").click(function() {
                            if($(this).prop("checked") === true) {
                                $(this).next().addClass("active");
                                $(".gfield_radio > li >  input[type=radio]").not(this).next().removeClass("active");
                            }
                        });
                });
                jQuery(document).bind("gform_post_conditional_logic", function() {
                    
                    /* ~~~~~ Register Form Step 3 ~~~~~ */
                    if($(".register-form__form").length) {
                        console.log('test')
                            $(function() {
                                // Define Fields to show in 3 Step
                                let selectedPacket = $packetsRadio.find('.ginput_container .gfield_radio li input:checked').next().text(),
                                    registerBillingAddressSex = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-sex .ginput_container_select > select option:selected').text(),
                                    registerBillingAddressName = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-name .ginput_container input').val(),
                                    registerBillingAddressLastName = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-last-name .ginput_container input').val(),
                                    registerBillingAddressCompany = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-company .ginput_container input').val(),
                                    registerBillingAddressNipEu = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-nip-eu .ginput_container input').val(),
                                    registerBillingAddressDepartament = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-departament .ginput_container input').val(),
                                    registerBillingAddressOrderNumber = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-order-number .ginput_container input').val(),
                                    registerBillingAddressStreet = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-street .ginput_container input').val(),
                                    registerBillingAddressHouseNumber = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-house-number .ginput_container input').val(),
                                    registerBillingAddressApartamentNumber = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-apartament-number .ginput_container input').val(),
                                    registerBillingAddressPostcode = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-postcode .ginput_container input').val(),
                                    registerBillingAddressCity = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-city .ginput_container input').val(),
                                    registerBillingAddressCountry = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .billing-address-country .ginput_container input').val();

                                console.log(selectedPacket);

                                // Append Selected Packet to Packet Value
                                $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .packet-wrapper .packet .packet__value').text(selectedPacket);

                                // Append Sex and Name and Last Name to Billing Address
                                if (registerBillingAddressSex && registerBillingAddressName && registerBillingAddressLastName) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__name').html(registerBillingAddressSex + ': ' + registerBillingAddressName + ' ' + registerBillingAddressLastName);
                                }

                                // Append Company to Billing Address
                                if (registerBillingAddressCompany) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__company').html('<b>Firma:</b>' + ' ' + registerBillingAddressCompany);
                                }

                                // Append NIP Eu to Billing Address
                                if (registerBillingAddressNipEu) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__nip-eu').html('<b>UST-ID-Nr.:</b>' + ' ' + registerBillingAddressNipEu);
                                }

                                // Append Departamnet to Billing Address
                                if (registerBillingAddressDepartament) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__departament').html('<b>Abteilung:</b>' + ' ' + registerBillingAddressDepartament);
                                }

                                // Append Order Number to Billing Address
                                if (registerBillingAddressOrderNumber) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__order-number').html('<b>Interne Bestellnummer:</b>' + ' ' + registerBillingAddressOrderNumber);
                                }

                                // Append Street and House Number to Billing Address
                                if (registerBillingAddressStreet && registerBillingAddressHouseNumber) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__street-and-number').html('<b>Adresse:</b>' + ' ' + registerBillingAddressStreet + ' ' + registerBillingAddressHouseNumber);
                                }

                                // Append Street and House Number and Apartament Number to Billing Address
                                if (registerBillingAddressStreet && registerBillingAddressHouseNumber && registerBillingAddressApartamentNumber) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__street-and-number').html('<b>Adresse:</b>' + ' ' + registerBillingAddressStreet + ' ' + registerBillingAddressHouseNumber + '/' + registerBillingAddressApartamentNumber);
                                }

                                // Append City and Postcode to Billing Address
                                if (registerBillingAddressPostcode && registerBillingAddressCity) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__postcode-and-city').html('<b>PLZ und Ort:</b>' + ' ' + registerBillingAddressPostcode + ' ' + registerBillingAddressCity);
                                }

                                // Append Country to Billing Address
                                if (registerBillingAddressCountry) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .billing-address-wrapper .billing-address .billing-address__country').html('<b>Land:</b>' + ' ' + registerBillingAddressCountry);
                                }

                                // Counters
                                let i = 1,
                                    j = 0,
                                    k = 0;

                                // Single Member Values
                                $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .members-added .members .row').html('');
                                $('.gform_wrapper form.register-form__form .members .gfield_repeater_wrapper .gfield_repeater .gfield_repeater_items .gfield_repeater_item').each(function() {
                                    let SingleRepeaterItemSex = $(this).find('.gfield_repeater_cell:nth-of-type(2) .ginput_container_select > select option:selected').text(),
                                        SingleRepeaterItemName = $(this).find('.gfield_repeater_cell:nth-of-type(3) .ginput_container > input').val(),
                                        SingleRepeaterItemLastName = $(this).find('.gfield_repeater_cell:nth-of-type(4) .ginput_container > input').val(),
                                        SingleRepeaterItemCompany = $(this).find('.gfield_repeater_cell:nth-of-type(5) .ginput_container > input').val(),
                                        SingleRepeaterItemDepartament = $(this).find('.gfield_repeater_cell:nth-of-type(6) .ginput_container > input').val(),
                                        SingleRepeaterItemEmail = $(this).find('.gfield_repeater_cell:nth-of-type(7) .ginput_container > input').val();

                                    if(i == 3) {
                                        j++;
                                        i = 0;
                                    }

                                    k++;
                                    i++;

                                    // Append Values to 3 Step of Form (Members)
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .members-added .members .row').append('<div class="col-md-4"><div class="single-member c-mt-4 c-mt-md-5 c-mt-xl-6"><span class="single-member__number font-weight-base-bold text-uppercase d-block">Teilnehmer ' + k + '</span>' + '<div class="box-values c-mt-2">' + SingleRepeaterItemSex + ' ' + SingleRepeaterItemName + ' ' + SingleRepeaterItemLastName + '<br><b>Firma: </b>' + SingleRepeaterItemCompany + '<br><b>Abteilung / Position: </b>' + SingleRepeaterItemDepartament + '<br><b>E-mail: </b>' + SingleRepeaterItemEmail + '</div></div></div>');
                                });

                                $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .gform_fields .quantity .ginput_container_number input').val(k - j);

                                if((k - j) > 1 ) {
                                    var normalPersons = 'Personen';
                                } else {
                                    var normalPersons = 'Person';
                                }

                                if(j > 1) {
                                    var freePersons = 'Personen';
                                } else {
                                    var freePersons = 'Person';
                                }

                                // Variables
                                let total = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .gform_fields .total .ginput_container input'),
                                    total_no_discount = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .gform_fields .total-no-discount .ginput_container input'),
                                    discount_field = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .gform_fields .discount-field .ginput_container input'),
                                    couponInput = $("#gf_coupon_codes_1").val(),
                                    total_no_discount_value = parseFloat($('.gform_wrapper form.register-form__form .gform_body #gform_page_1_1 .gform_page_fields .gform_fields .coupon .ginput_container #gf_total_no_discount_1').val()),
                                    total_brutto = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .gform_fields .total-brutto .ginput_container input'),
                                    quanity_full = $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_2 .gform_page_fields .gform_fields .quanity-full .ginput_container input');

                                if (couponInput) {
                                    if($packet2.is(":checked")) {
                                        var discount_price = 990;
                                    } else if($packet3.is(":checked")) {
                                        var discount_price = 760;
                                    }
                                } else {
                                    var discount_price = 0;
                                }

                                if (couponInput) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__persons').html(k - j + ' ' + normalPersons + ' x ' + (total_no_discount_value/(k - j)) + '€ - ' + (k - j) + ' x ' + discount_price + '€ (Gutschein)' + ' zzgl. 19% MwSt.' );
                                } else {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__persons').html(k - j + ' ' + normalPersons + ' x ' + (total_no_discount_value/(k - j)) + ' € zzgl. 19% MwSt.' );
                                }

                                // Append HTML Prices Free Persons
                                if(j > 0) {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__free-persons').html(j + ' ' + freePersons + ' gratis' );
                                }
                                // Calulate price Netto
                                $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__price-netto').html('NETTO:<span class="price-details__price-netto-value"> ' + (total_no_discount_value * 1 - (discount_price * (k - j))).toFixed(2) + ' €</span>');

                                // Calulate price Brutto

                                if (couponInput) {
//                                    if($packet2.is(":checked")) {
//                                        $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__price-brutto').html('BRUTTO: 0.00 €');
//                                    } else {
                                        $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__price-brutto').html('BRUTTO: ' + ((total_no_discount_value - (discount_price * (k - j))) * 1.19).toFixed(2) + ' €');
//                                    }
                                } else {
                                    $('.gform_wrapper form.register-form__form .gform_body #gform_page_1_3 .gform_page_fields .price-details-wrapper .price-details .price-details__price-brutto').html('BRUTTO: ' + (total_no_discount_value * 1.19).toFixed(2) + ' €');
                                }


                                // Fields to mail

                                    // Quanity

                                        quanity_full.prop('type', 'hidden');

                                        quanity_full.val(k);

                                    // Total no discount

                                        // Replace input from text to hidden
                                        total_no_discount.prop('type', 'hidden');

                                        // Change Value
                                        total_no_discount.val((total_no_discount_value * 1).toFixed(2) + ' €');

                                    // Discount

                                        // Replace input from text to hidden
                                        discount_field.prop('type', 'hidden');

                                        // Change Value
                                        if(discount_price) {
                                            discount_field.val((discount_price * (k - j)).toFixed(2) + ' €');
                                        } else {
                                            discount_field.val('0 €');
                                        }

                                    // Total

                                        // Replace input from text to hidden
                                        total.prop('type', 'hidden');

                                        // Change Value
                                        if(discount_price) {
                                            total.val((total_no_discount_value * 1 - (discount_price * (k - j))).toFixed(2) + ' €');
                                        } else {
                                            total.val((total_no_discount_value * 1).toFixed(2) + ' €');
                                        }

                                    // Total Brutto

                                        // Replace input from text to hidden
                                        total_brutto.prop('type', 'hidden');

                                        // Change Value
                                        if(discount_price) {
//                                            if($packet2.is(":checked")) {
//                                                total_brutto.val('0.00 €');
//                                            } else {
                                                total_brutto.val(((total_no_discount_value - (discount_price * (k - j))) * 1.19).toFixed(2) + ' €');
//                                            }
                                        } else {
                                            total_brutto.val((total_no_discount_value * 1.19).toFixed(2) + ' €');
                                        }
                            });
                        }

                    /* ~~~~~ Register Form Partner Form 01 Step 3 ~~~~~ */

                    if($(".partner-form__form").length) {
                        $(function() {

                            // Define Fields to show in 3 Step
                            let partnerFormMemberSex = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-sex .ginput_container_select > select option:selected').text(),
                                partnerFormMemberName = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-name .ginput_container input').val(),
                                partnerFormMemberLastName = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-last-name .ginput_container input').val(),
                                partnerFormMemberCompany = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-company .ginput_container input').val(),
                                partnerFormMemberEmail = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-email .ginput_container input').val(),
                                partnerFormMemberPhoneNumber = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-phone-number .ginput_container input').val(),


                                partnerFormBillingAddressSex = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-sex .ginput_container_select > select option:selected').text(),
                                partnerFormBillingAddressName = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-name .ginput_container input').val(),
                                partnerFormBillingAddressLastName = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-last-name .ginput_container input').val(),
                                partnerFormBillingAddressCompany = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-company .ginput_container input').val(),
                                partnerFormBillingAddressNipEu = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-nip-eu .ginput_container input').val(),
                                partnerFormBillingAddressDepartament = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-departament .ginput_container input').val(),
                                partnerFormBillingAddressOrderNumber = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-order-number .ginput_container input').val(),
                                partnerFormBillingAddressStreet = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-street .ginput_container input').val(),
                                partnerFormBillingAddressHouseNumber = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-house-number .ginput_container input').val(),
                                partnerFormBillingAddressEmail = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-email .ginput_container input').val(),
                                partnerFormBillingAddressPostcode = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-postcode .ginput_container input').val(),
                                partnerFormBillingAddressCity = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-city .ginput_container input').val(),
                                partnerFormBillingAddressCountry = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-country .ginput_container input').val();


                            // Member

                            // Append Sex and Name and Last Name to Member
                            if (partnerFormMemberSex && partnerFormMemberName && partnerFormMemberLastName) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-wrapper .member .member__name').html(partnerFormMemberSex + ' ' + partnerFormMemberName + ' ' + partnerFormMemberLastName);
                            }

                            // Append Company to Member
                            if (partnerFormMemberCompany) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-wrapper .member .member__company').html(partnerFormMemberCompany);
                            }

                            // Append Email to Member
                            if (partnerFormMemberEmail) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-wrapper .member .member__email').html('<b>E-Mail:</b>' + ' ' + partnerFormMemberEmail);
                            }

                            // Append Phone Number to Member
                            if (partnerFormMemberPhoneNumber) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-wrapper .member .member__phone').html('<b>Telefon:</b>' + ' ' + partnerFormMemberPhoneNumber);
                            }


                            // Billing address

                            // Append Company to Billing Address
                            if (partnerFormBillingAddressCompany) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__company').html(partnerFormBillingAddressCompany);
                            }

                            // Append Sex and Name and Last Name to Billing Address
                            if (partnerFormBillingAddressSex && partnerFormBillingAddressName && partnerFormBillingAddressLastName) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__name').html(partnerFormBillingAddressSex + ': ' + partnerFormBillingAddressName + ' ' + partnerFormBillingAddressLastName);
                            }

                            // Append NIP Eu to Billing Address
                            if (partnerFormBillingAddressNipEu) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__nip-eu').html('<b>UST-ID-Nr.:</b>' + ' ' + partnerFormBillingAddressNipEu);
                            }

                            // Append Departamnet to Billing Address
                            if (partnerFormBillingAddressDepartament) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__departament').html('<b>Abteilung / Position:</b>' + ' ' + partnerFormBillingAddressDepartament);
                            }

                            // Append Order Number to Billing Address
                            if (partnerFormBillingAddressOrderNumber) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__order-number').html('<b>Interne Bestellnummer:</b>' + ' ' + partnerFormBillingAddressOrderNumber);
                            }

                            // Append Street and House Number to Billing Address
                            if (partnerFormBillingAddressStreet && partnerFormBillingAddressHouseNumber) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__street-and-number').html(partnerFormBillingAddressStreet + ' ' + partnerFormBillingAddressHouseNumber);
                            }

                            // Append Email to Billing Address
                            if (partnerFormBillingAddressEmail) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__email').html('<b>Email:</b>' + ' ' + partnerFormBillingAddressEmail);
                            }

                            // Append City and Postcode to Billing Address
                            if (partnerFormBillingAddressPostcode && partnerFormBillingAddressCity) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__postcode-and-city').html(partnerFormBillingAddressPostcode + ' ' + partnerFormBillingAddressCity);
                            }

                            // Append Country to Billing Address
                            if (partnerFormBillingAddressCountry) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .billing-address-wrapper .billing-address .billing-address__country').html(partnerFormBillingAddressCountry);
                            }

                            // Variables
                            let total_netto_value = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .gfield_total .ginput_container input').val(),
                                total_netto_input = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .gfield_total .ginput_container input'),
                                total_netto_input_mail = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .total-netto .ginput_container input'),
                                total_brutto = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .total-brutto .ginput_container input'),
                                packet_price = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .packet .ginput_container .ginput_product_price').html(),
                                additional_stand_manager_quanity = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-stand-manager .ginput_container .ginput_quantity').val(),
                                additional_stand_manager_price = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-stand-manager .ginput_container .ginput_product_price').html(),
                                addtional_member_quanity = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-member .ginput_container .ginput_quantity').val(),
                                addtional_member_price = $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-member .ginput_container .ginput_product_price').html();


                            // Append Addtional Stand Manager to Member Additional Options
                            if (additional_stand_manager_quanity) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-wrapper .additional-options .additional-options__addtional-stand-manager').html(additional_stand_manager_quanity + ' weitere Standbetreuer x <b>' + additional_stand_manager_price  + '</b> zzgl. 19% MwSt.' );
                            }

                            // Append Addtional Member to Member Additional Options
                            if (addtional_member_quanity) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .member-wrapper .additional-options .additional-options__addtional-member').html("Vortragsslot");
                            }

                            // Packet
                            $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .price-details-wrapper .price-details .price-details__packet').html('Partner Paket <b>' + packet_price  + '</b> zzgl. 19% MwSt.' );

                            // Addtional Stand Manager
                            if(additional_stand_manager_quanity) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .additional-stand-manager-true .ginput_container_radio .gfield_radio li:first-of-type input[type="radio"]').click();

                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-stand-manager-total-price .ginput_container input').attr("value", additional_stand_manager_quanity * parseInt(additional_stand_manager_price));

                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .price-details-wrapper .price-details .price-details__addtional-stand-managers').html(additional_stand_manager_quanity + ' weitere Standbetreuer x <b>' + additional_stand_manager_price  + '</b> zzgl. 19% MwSt.' );
                            }

                            // Additional Member
                            if(addtional_member_quanity) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .additional-member-true .ginput_container_radio .gfield_radio li:first-of-type input[type="radio"]').click();

                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .price-details-wrapper .price-details .price-details__addtional-member').html('Vortragsslot <b>' + addtional_member_price  + '</b> zzgl. 19% MwSt.' );
                            }

                            // Calulate price Netto
                            $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .price-details-wrapper .price-details .price-details__price-netto').html('NETTO:<span class="price-details__price-netto-value"> ' + (total_netto_value * 1).toFixed(2) + ' €</span>');

                            // Calulate price Brutto
                            $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .price-details-wrapper .price-details .price-details__price-brutto').html('BRUTTO: ' + (total_netto_value * 1.19).toFixed(2) + ' €');

                            // Fields to mail

                                // Total Netto

                                // Replace input from text to hidden
                                total_netto_input_mail.prop('type', 'hidden');

                                total_netto_input_mail.val((total_netto_value * 1).toFixed(2) + ' €');


                                // Total Brutto

                                // Replace input from text to hidden
                                total_brutto.prop('type', 'hidden');

                                // Change Value
                                total_brutto.val((total_netto_value * 1.19).toFixed(2) + ' €');
                        });

                        /* ~~~~~~~~~~ Paramters function for Partner Form ~~~~~~~~~~ */

                        $(function() {

                            // Show all parametrs

                            let getUrlParameter = function getUrlParameter(sParam) {
                                let sPageURL = window.location.search.substring(1),
                                    sURLVariables = sPageURL.split('&'),
                                    sParameterName,
                                    i;

                                for (i = 0; i < sURLVariables.length; i++) {
                                    sParameterName = sURLVariables[i].split('=');

                                    if (sParameterName[0] === sParam) {
                                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                                    }
                                }
                            };

                            let additional_stand_manager = getUrlParameter('additional-stand-manager'),
                                additional_member = getUrlParameter('additional-member');

                            if (additional_member && additional_stand_manager) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-member .ginput_container .ginput_quantity').attr("value", "1");
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-stand-manager .ginput_container .ginput_quantity').attr("value", additional_stand_manager);
                            } else if (additional_member) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-member .ginput_container .ginput_quantity').attr("value", "1");
                            } else if (additional_stand_manager) {
                                $('.gform_wrapper form.partner-form__form .gform_body .gform_page .gform_page_fields .gform_fields .additional-stand-manager .ginput_container .ginput_quantity').attr("value", additional_stand_manager);
                            }
                        });
                    }
                });

        });

    })(jQuery);
